import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { xpoAuthCanMatch } from '@xpo-ltl/ngx-auth';
import { NotAuthorizedComponent } from '@shared/dialog/not-authorized/not-authorized.component';
import { AppRoutes } from '@enums/app-routes.enum';
import { NotAuthorizedRedirectGuard } from '@shared/dialog/not-authorized/not-authorized-redirect.guard';
import { AuthRedirectComponent } from '@shared/components/auth-redirect/auth-redirect.component';

const routerDefinitions: Routes = [
  {
    path: AppRoutes.NOT_AUTHORIZED_PAGE,
    component: NotAuthorizedComponent,
    canActivate: [NotAuthorizedRedirectGuard],
    canMatch: [xpoAuthCanMatch()],
  },
  // ADD ANY NEW ROUTE / PAGE HERE
  {
    path: AppRoutes.OFF_BILL_INCENTIVE,
    loadChildren: () => import('./obi/obi.module').then((m) => m.ObiModule),
    // FOR SSO
    canMatch: [xpoAuthCanMatch()],
  },
  {
    path: AppRoutes.OBI_AGREEMENT,
    loadChildren: () => import('./agreement/agreement.module').then((m) => m.AgreementModule),
    // FOR SSO
    canMatch: [xpoAuthCanMatch()],
  },
  {
    path: '**',
    // Not a redirectTo: that target is itself guarded by xpoAuthCanMatch(), so while
    // isLoggedIn$ is still false the redirect target fails to match too, and the router falls
    // through further to XpoPageNotFoundRoutingModule's own unguarded wildcard, rendering a
    // real "Page Not Found" screen. A plain component route always matches, so it navigates
    // onward itself only once isLoggedIn$ confirms it's safe to - see AuthRedirectComponent.
    component: AuthRedirectComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routerDefinitions, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
